import i18n from "i18next";
import React from "react";

export const MyResetFiltersDisplay = ({ resetFilters, hasFilters }) => (
  <button onClick={resetFilters} disabled={!hasFilters} type="reset" className="btn btn-info">
    {i18n.t("Clear filters")}
  </button>
);
